import { createContext, createElement } from 'react'


import { useContext } from 'react';
export interface IPricingInitialValue {}

export const usePricing = (initialValue?: IPricingInitialValue) => {
  return {}
}

const Context = createContext<ReturnType<typeof usePricing>>(null!)

export const PricePageProvider = ({
  children,
  initialValue,
}: {
  children: React.ReactNode
  initialValue?: IPricingInitialValue
}) => {
  const value = usePricing(initialValue)
  return createElement(
    Context.Provider,
    {
      value,
    },
    children,
  )
}

export const usePricePage = () => {
  const context = useContext(Context)
  if (!context) {
    throw new Error('usePricePage must be used within a PricePageProvider')
  }
  return context
}
